
/* ---------------------------------------------------------------
                    MODULE: MAP
-----------------------------------------------------------------*/

/* This function draws the map.

*/

// --------------------------- IMPORTS ---------------------------

// Third party
import { select } from "d3-selection"
// import 'leaflet.markercluster'
import { scaleOrdinal } from "d3-scale";
import { drawLegendHtml } from "./legend";

// My imports
import { titleCase } from "./parse"
// --------------------------- DRAW CHART ---------------------------

export const drawMap = (rawData, props) => {

  //-------------------- SET UP ------------------------

  // GET DESIRED DATA
  const data = rawData.sffList.data

  // DESTRUCTURE PROPS
  const {
    mapContainerClass,
    legendContainerClass,
    graphicInner,
    breakpointSmallScreen,
  } = props;

  // RESPONSIVE: GET WIDTH
  // We get width of graphicInner and then pass it into render to get our svg width
  const width = graphicInner.node().offsetWidth;

  // CONTINENTAL USA BOUNDS
  const continentalUsaBounds = L.latLngBounds(
    L.latLng(49, -120), //northwest
    L.latLng(24, -81)  //Northeast
  );

  // COLOR SCALE FOR LEGEND + MAP ICONS
  const colorScale = scaleOrdinal()
    .range([
      "#E6842A",
      '#E3BA22'
  ])
    .domain([
      'SFF',
      'SFF Candidate',
  ])

  //-------------------- DRAW MAP ------------------------


  // INIT MAP
  // We set default location and zoom level here
  // location: center of Pa.
  const map = L.map(mapContainerClass)
    .fitBounds(continentalUsaBounds)
    // .setView([40.590752, -77.209755], 6); // NOTE: we use negative lat because we're in western hemisphere

  // ADD BASEMAP
  // Carto DB Positron
  const layer = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}' + (L.Browser.retina ? '@2x.png' : '.png'), {
    attribution:'&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>',
    subdomains: 'abcd',
    // maxZoom: 20,
    // minZoom: 0,
  }).addTo(map)

  // INIT ICON - SFF
  const iconSff = L.icon({
    iconUrl: 'images/pin-red.svg',
    iconSize: [32, 37], // size of the icon
    iconAnchor: [16, 37], // point of the icon which will correspond to marker's location
    popupAnchor: [11.5, -30] // point from which the popup should open relative to the iconAnchor
  });

  // INIT ICON - SFF CANDIDATE
  const iconCand = L.icon({
    iconUrl: 'images/pin-black.svg',
    iconSize: [32, 37], // size of the icon
    iconAnchor: [16, 37], // point of the icon which will correspond to marker's location
    popupAnchor: [11.5, -30] // point from which the popup should open relative to the iconAnchor
  });

  // ADD GEO JSON LAYER
  const geojsonFacilities = L.geoJSON(data, {
    style: function (feature) {
      return {
        fillOpacity: 1,
        fillColor: colorScale(feature.properties.status), // determine color from ColorScale
        color: 'black',
        weight: 0.1
      }
    },
    pointToLayer: function(feature, latlng) {
      return L.circleMarker(latlng, {
        radius: 3.5
      }
    )
    },
    onEachFeature: function(feature, layer) {
      if (feature.geometry.type==='Point') {
        const {
          PROVNAME,
          status,
          CITY,
          STATE
        } = feature.properties
        const provnameFormatted = titleCase(PROVNAME)
        const formattedStatus = status == "SFF" ? "Special Focus Facility" : "SFF Candidate"
        const cityFormatted = titleCase(CITY)
        // const fontColor = colorScale(status)
        const html = `
        <div"><strong>${provnameFormatted}</strong></div">
        <div>${formattedStatus}</div>
        <div>${cityFormatted}, ${STATE}</div>
        `
        layer.bindPopup(html)
      }
    }
  }).addTo(map)

  //-------------------- EVENTS ------------------------


  map.on('zoomend', (e) => {
    var currentZoom = map.getZoom();
    console.log("Current Zoom" + " " + currentZoom);
    const radiusMultiplier = 1
    let radius = currentZoom * radiusMultiplier
    // if (currentZoom > 6) {
    //   radius = currentZoom
    // } else {
    //   radius = 3.5
    //   }
    geojsonFacilities.setStyle({
      radius
    })

    });

  //-------------------- DRAW LEGEND ------------------------
  
  // We create an html legend for the map icons
  const keys = colorScale.domain()
  drawLegendHtml(legendContainerClass, colorScale, keys)


  //-------------------- UPDATE IFRAME ------------------------

  // pymChild sends the height to pym script in iframe, we do this because
  // table height changes based on user interaction.
  pymChild.sendHeight();

}